export default "__VITE_ASSET__kKsoVr50__"